import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { IconComponent } from '../icon/icon';

/** Nœud générique d'arborescence (projets/sous-projets, tâches/sous-tâches...). */
export interface TreeNode<T = unknown> {
  label: string;
  data?: T;
  children?: TreeNode<T>[];
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ui-tree',
  imports: [NgTemplateOutlet, IconComponent],
  styleUrl: './tree.scss',
  templateUrl: './tree.html',
})
export class TreeComponent<T = unknown> {
  /** Racines de l'arborescence (récurrence gérée par le template). */
  readonly nodes = input<TreeNode<T>[]>([]);
}
